import CSS from '../Image/css.png'
import C from '../Image/c.png'
import CPP from "../Image/cpp.png"
import Python from "../Image/python.png"
import HTML from "../Image/html5.png"
import JS from "../Image/js.jpg"
import MYSQL from "../Image/mysql.png"
import ANGULAR from "../Image/Angular.png"
import REACT from "../Image/react.jpg"
const SkillData=[
    {
        title:"C",
        per:"70%",
        imgsrc:C,
    },
    {
        title:"CPP",
        per:"60%",
        imgsrc:CPP,
    },
    {
        title:"PYTHON",
        per:"20%",
        imgsrc:Python,
    },
    {
        title:"HTML 5",
        per:"85%",
        imgsrc:HTML,
    },
    {
        title:"CSS 3",
        per:"80%",
        imgsrc:CSS,
    },
    {
        title:"JAVA SCRIPT",
        per:"60%",
        imgsrc:JS,
    },
    {
        title:"MY SQL",
        per:"50%",
        imgsrc:MYSQL,
    },
    {
        title:"ANGULAR",
        per:"40%",
        imgsrc:ANGULAR,
    },
    {
        title:"REACT",
        per:"60%",
        imgsrc:REACT,
    },
]
export default SkillData;